/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { OrbitalApesLimited } from "../OrbitalApesLimited";

export class OrbitalApesLimited__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<OrbitalApesLimited> {
    return super.deploy(overrides || {}) as Promise<OrbitalApesLimited>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): OrbitalApesLimited {
    return super.attach(address) as OrbitalApesLimited;
  }
  connect(signer: Signer): OrbitalApesLimited__factory {
    return super.connect(signer) as OrbitalApesLimited__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): OrbitalApesLimited {
    return new Contract(address, _abi, signerOrProvider) as OrbitalApesLimited;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: false,
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "ApprovalForAll",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        indexed: false,
        internalType: "uint256[]",
        name: "values",
        type: "uint256[]",
      },
    ],
    name: "TransferBatch",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "TransferSingle",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "value",
        type: "string",
      },
      {
        indexed: true,
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "URI",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address[]",
        name: "accounts",
        type: "address[]",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
    ],
    name: "balanceOfBatch",
    outputs: [
      {
        internalType: "uint256[]",
        name: "",
        type: "uint256[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "exists",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    name: "ipfsHashes",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
    ],
    name: "isApprovedForAll",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256[]",
        name: "ids",
        type: "uint256[]",
      },
      {
        internalType: "uint256[]",
        name: "amounts",
        type: "uint256[]",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeBatchTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "data",
        type: "bytes",
      },
    ],
    name: "safeTransferFrom",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "operator",
        type: "address",
      },
      {
        internalType: "bool",
        name: "approved",
        type: "bool",
      },
    ],
    name: "setApprovalForAll",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "string",
        name: "ipfsHash",
        type: "string",
      },
    ],
    name: "setTokenIPFSHash",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "id",
        type: "uint256",
      },
    ],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
    ],
    name: "uri",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "0x60c0604052601260808190527113dc989a5d185b105c195cd31a5b5a5d195960721b60a090815262000035916006919062000244565b506040805180820190915260038082526213d05360ea1b6020909201918252620000629160079162000244565b503480156200007057600080fd5b506040805160208101909152600081526200008b81620000cc565b506200009a6000335b620000e5565b620000c67f9f2df0fed2c77648de5860a4cc508cd0818c85b8b8a1ab4ceeef8d981c8956a63362000094565b62000327565b8051620000e190600290602084019062000244565b5050565b620000e182826200010282826200012e60201b62000ae81760201c565b60008281526005602090815260409091206200012991839062000b6f620001d2821b17901c565b505050565b60008281526004602090815260408083206001600160a01b038516845290915290205460ff16620000e15760008281526004602090815260408083206001600160a01b03851684529091529020805460ff191660011790556200018e3390565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45050565b6000620001e9836001600160a01b038416620001f2565b90505b92915050565b60008181526001830160205260408120546200023b57508154600181810184556000848152602080822090930184905584548482528286019093526040902091909155620001ec565b506000620001ec565b8280546200025290620002ea565b90600052602060002090601f016020900481019282620002765760008555620002c1565b82601f106200029157805160ff1916838001178555620002c1565b82800160010185558215620002c1579182015b82811115620002c1578251825591602001919060010190620002a4565b50620002cf929150620002d3565b5090565b5b80821115620002cf5760008155600101620002d4565b600181811c90821680620002ff57607f821691505b602082108114156200032157634e487b7160e01b600052602260045260246000fd5b50919050565b6124db80620003376000396000f3fe608060405234801561001057600080fd5b50600436106101575760003560e01c806391d14854116100c3578063bd85b0391161007c578063bd85b03914610307578063ca15c87314610327578063d53913931461033a578063d547741f14610361578063e985e9c514610374578063f242432a146103b057610157565b806391d14854146102ab57806395d89b41146102be578063a217fddf146102c6578063a22cb465146102ce578063a4de2f5c146102e1578063b485a58a146102f457610157565b80632eb2c2d6116101155780632eb2c2d6146102055780632f2ff15d1461021857806336568abe1461022b5780634e1273f41461023e5780634f558e791461025e5780639010d07c1461028057610157565b8062fdd58e1461015c57806301ffc9a71461018257806306fdde03146101a55780630e89341c146101ba578063156e29f6146101cd578063248a9ca3146101e2575b600080fd5b61016f61016a366004611dce565b6103c3565b6040519081526020015b60405180910390f35b610195610190366004611f4f565b61045d565b6040519015158152602001610179565b6101ad610470565b6040516101799190612194565b6101ad6101c8366004611ef4565b6104fe565b6101e06101db366004611df7565b6105a0565b005b61016f6101f0366004611ef4565b60009081526004602052604090206001015490565b6101e0610213366004611c8b565b61064a565b6101e0610226366004611f0c565b6106f3565b6101e0610239366004611f0c565b610718565b61025161024c366004611e29565b6107a6565b6040516101799190612153565b61019561026c366004611ef4565b600090815260036020526040902054151590565b61029361028e366004611f2e565b610908565b6040516001600160a01b039091168152602001610179565b6101956102b9366004611f0c565b610927565b6101ad610952565b61016f600081565b6101e06102dc366004611d94565b61095f565b6101ad6102ef366004611ef4565b610971565b6101e0610302366004611f87565b61098a565b61016f610315366004611ef4565b60009081526003602052604090205490565b61016f610335366004611ef4565b610a13565b61016f7f9f2df0fed2c77648de5860a4cc508cd0818c85b8b8a1ab4ceeef8d981c8956a681565b6101e061036f366004611f0c565b610a2a565b610195610382366004611c59565b6001600160a01b03918216600090815260016020908152604080832093909416825291909152205460ff1690565b6101e06103be366004611d31565b610a4f565b60006001600160a01b0383166104345760405162461bcd60e51b815260206004820152602b60248201527f455243313135353a2062616c616e636520717565727920666f7220746865207a60448201526a65726f206164647265737360a81b60648201526084015b60405180910390fd5b506000818152602081815260408083206001600160a01b03861684529091529020545b92915050565b600061046882610b84565b90505b919050565b6006805461047d90612337565b80601f01602080910402602001604051908101604052809291908181526020018280546104a990612337565b80156104f65780601f106104cb576101008083540402835291602001916104f6565b820191906000526020600020905b8154815290600101906020018083116104d957829003601f168201915b505050505081565b600081815260086020526040902080546060919061051b90612337565b80601f016020809104026020016040519081016040528092919081815260200182805461054790612337565b80156105945780601f1061056957610100808354040283529160200191610594565b820191906000526020600020905b81548152906001019060200180831161057757829003601f168201915b50505050509050919050565b6105cc7f9f2df0fed2c77648de5860a4cc508cd0818c85b8b8a1ab4ceeef8d981c8956a66102b9610ba9565b61062a5760405162461bcd60e51b815260206004820152602960248201527f4f72626974616c417065734c696d697465643a2063616c6c6572206d7573742060448201526831329036b4b73a32b960b91b606482015260840161042b565b61064583838360405180602001604052806000815250610bae565b505050565b610652610ba9565b6001600160a01b0316856001600160a01b03161480610678575061067885610382610ba9565b6106df5760405162461bcd60e51b815260206004820152603260248201527f455243313135353a207472616e736665722063616c6c6572206973206e6f74206044820152711bdddb995c881b9bdc88185c1c1c9bdd995960721b606482015260840161042b565b6106ec8585858585610cdc565b5050505050565b60008281526004602052604090206001015461070e81610eee565b6106458383610f02565b610720610ba9565b6001600160a01b0316816001600160a01b0316146107985760405162461bcd60e51b815260206004820152602f60248201527f416363657373436f6e74726f6c3a2063616e206f6e6c792072656e6f756e636560448201526e103937b632b9903337b91039b2b63360891b606482015260840161042b565b6107a28282610f24565b5050565b6060815183511461080b5760405162461bcd60e51b815260206004820152602960248201527f455243313135353a206163636f756e747320616e6420696473206c656e677468604482015268040dad2e6dac2e8c6d60bb1b606482015260840161042b565b6000835167ffffffffffffffff81111561083557634e487b7160e01b600052604160045260246000fd5b60405190808252806020026020018201604052801561085e578160200160208202803683370190505b50905060005b8451811015610900576108c585828151811061089057634e487b7160e01b600052603260045260246000fd5b60200260200101518583815181106108b857634e487b7160e01b600052603260045260246000fd5b60200260200101516103c3565b8282815181106108e557634e487b7160e01b600052603260045260246000fd5b60209081029190910101526108f98161239f565b9050610864565b509392505050565b60008281526005602052604081206109209083610f46565b9392505050565b60009182526004602090815260408084206001600160a01b0393909316845291905290205460ff1690565b6007805461047d90612337565b6107a261096a610ba9565b8383610f52565b6008602052600090815260409020805461047d90612337565b61099760006102b9610ba9565b6109f45760405162461bcd60e51b815260206004820152602860248201527f4f72626974616c417065734c696d697465643a2063616c6c6572206d7573742060448201526731329030b236b4b760c11b606482015260840161042b565b6000828152600860209081526040909120825161064592840190611ab8565b600081815260056020526040812061046890611033565b600082815260046020526040902060010154610a4581610eee565b6106458383610f24565b610a57610ba9565b6001600160a01b0316856001600160a01b03161480610a7d5750610a7d85610382610ba9565b610adb5760405162461bcd60e51b815260206004820152602960248201527f455243313135353a2063616c6c6572206973206e6f74206f776e6572206e6f7260448201526808185c1c1c9bdd995960ba1b606482015260840161042b565b6106ec858585858561103d565b610af28282610927565b6107a25760008281526004602090815260408083206001600160a01b03851684529091529020805460ff19166001179055610b2b610ba9565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45050565b6000610920836001600160a01b038416611180565b60006001600160e01b03198216635a05180f60e01b14806104685750610468826111cf565b335b90565b6001600160a01b038416610c0e5760405162461bcd60e51b815260206004820152602160248201527f455243313135353a206d696e7420746f20746865207a65726f206164647265736044820152607360f81b606482015260840161042b565b6000610c18610ba9565b90506000610c25856111f4565b90506000610c32856111f4565b9050610c438360008985858961124d565b6000868152602081815260408083206001600160a01b038b16845290915281208054879290610c739084906122a2565b909155505060408051878152602081018790526001600160a01b03808a1692600092918716917fc3d58168c5ae7397731d063d5bbf3d657854427343f4c083240f7aacaa2d0f62910160405180910390a4610cd3836000898989896113fe565b50505050505050565b8151835114610d3e5760405162461bcd60e51b815260206004820152602860248201527f455243313135353a2069647320616e6420616d6f756e7473206c656e677468206044820152670dad2e6dac2e8c6d60c31b606482015260840161042b565b6001600160a01b038416610d645760405162461bcd60e51b815260040161042b906121ef565b6000610d6e610ba9565b9050610d7e81878787878761124d565b60005b8451811015610e80576000858281518110610dac57634e487b7160e01b600052603260045260246000fd5b602002602001015190506000858381518110610dd857634e487b7160e01b600052603260045260246000fd5b602090810291909101810151600084815280835260408082206001600160a01b038e168352909352919091205490915081811015610e285760405162461bcd60e51b815260040161042b90612234565b6000838152602081815260408083206001600160a01b038e8116855292528083208585039055908b16825281208054849290610e659084906122a2565b9250508190555050505080610e799061239f565b9050610d81565b50846001600160a01b0316866001600160a01b0316826001600160a01b03167f4a39dc06d4c0dbc64b70af90fd698a233a518aa5d07e595d983b8c0526c8f7fb8787604051610ed0929190612166565b60405180910390a4610ee6818787878787611569565b505050505050565b610eff81610efa610ba9565b611633565b50565b610f0c8282610ae8565b60008281526005602052604090206106459082610b6f565b610f2e8282611697565b6000828152600560205260409020610645908261171c565b60006109208383611731565b816001600160a01b0316836001600160a01b03161415610fc65760405162461bcd60e51b815260206004820152602960248201527f455243313135353a2073657474696e6720617070726f76616c20737461747573604482015268103337b91039b2b63360b91b606482015260840161042b565b6001600160a01b03838116600081815260016020908152604080832094871680845294825291829020805460ff191686151590811790915591519182527f17307eab39ab6107e8899845ad3d59bd9653f200f220920489ca2b5937696c31910160405180910390a3505050565b6000610468825490565b6001600160a01b0384166110635760405162461bcd60e51b815260040161042b906121ef565b600061106d610ba9565b9050600061107a856111f4565b90506000611087856111f4565b905061109783898985858961124d565b6000868152602081815260408083206001600160a01b038c168452909152902054858110156110d85760405162461bcd60e51b815260040161042b90612234565b6000878152602081815260408083206001600160a01b038d8116855292528083208985039055908a168252812080548892906111159084906122a2565b909155505060408051888152602081018890526001600160a01b03808b16928c821692918816917fc3d58168c5ae7397731d063d5bbf3d657854427343f4c083240f7aacaa2d0f62910160405180910390a4611175848a8a8a8a8a6113fe565b505050505050505050565b60008181526001830160205260408120546111c757508154600181810184556000848152602080822090930184905584548482528286019093526040902091909155610457565b506000610457565b60006001600160e01b03198216637965db0b60e01b1480610468575061046882611769565b6040805160018082528183019092526060916000919060208083019080368337019050509050828160008151811061123c57634e487b7160e01b600052603260045260246000fd5b602090810291909101015292915050565b6001600160a01b0385166112f05760005b83518110156112ee5782818151811061128757634e487b7160e01b600052603260045260246000fd5b6020026020010151600360008684815181106112b357634e487b7160e01b600052603260045260246000fd5b6020026020010151815260200190815260200160002060008282546112d891906122a2565b909155506112e790508161239f565b905061125e565b505b6001600160a01b038416610ee65760005b8351811015610cd357600084828151811061132c57634e487b7160e01b600052603260045260246000fd5b60200260200101519050600084838151811061135857634e487b7160e01b600052603260045260246000fd5b60200260200101519050600060036000848152602001908152602001600020549050818110156113db5760405162461bcd60e51b815260206004820152602860248201527f455243313135353a206275726e20616d6f756e74206578636565647320746f74604482015267616c537570706c7960c01b606482015260840161042b565b600092835260036020526040909220910390556113f78161239f565b9050611301565b6001600160a01b0384163b15610ee65760405163f23a6e6160e01b81526001600160a01b0385169063f23a6e6190611442908990899088908890889060040161210e565b602060405180830381600087803b15801561145c57600080fd5b505af192505050801561148c575060408051601f3d908101601f1916820190925261148991810190611f6b565b60015b611539576114986123e6565b806308c379a014156114d257506114ad6123fd565b806114b857506114d4565b8060405162461bcd60e51b815260040161042b9190612194565b505b60405162461bcd60e51b815260206004820152603460248201527f455243313135353a207472616e7366657220746f206e6f6e20455243313135356044820152732932b1b2b4bb32b91034b6b83632b6b2b73a32b960611b606482015260840161042b565b6001600160e01b0319811663f23a6e6160e01b14610cd35760405162461bcd60e51b815260040161042b906121a7565b6001600160a01b0384163b15610ee65760405163bc197c8160e01b81526001600160a01b0385169063bc197c81906115ad90899089908890889088906004016120b0565b602060405180830381600087803b1580156115c757600080fd5b505af19250505080156115f7575060408051601f3d908101601f191682019092526115f491810190611f6b565b60015b611603576114986123e6565b6001600160e01b0319811663bc197c8160e01b14610cd35760405162461bcd60e51b815260040161042b906121a7565b61163d8282610927565b6107a257611655816001600160a01b031660146117b9565b6116608360206117b9565b60405160200161167192919061203b565b60408051601f198184030181529082905262461bcd60e51b825261042b91600401612194565b6116a18282610927565b156107a25760008281526004602090815260408083206001600160a01b03851684529091529020805460ff191690556116d8610ba9565b6001600160a01b0316816001600160a01b0316837ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b60405160405180910390a45050565b6000610920836001600160a01b03841661199b565b600082600001828154811061175657634e487b7160e01b600052603260045260246000fd5b9060005260206000200154905092915050565b60006001600160e01b03198216636cdb3d1360e11b148061179a57506001600160e01b031982166303a24d0760e21b145b8061046857506301ffc9a760e01b6001600160e01b0319831614610468565b606060006117c88360026122ba565b6117d39060026122a2565b67ffffffffffffffff8111156117f957634e487b7160e01b600052604160045260246000fd5b6040519080825280601f01601f191660200182016040528015611823576020820181803683370190505b509050600360fc1b8160008151811061184c57634e487b7160e01b600052603260045260246000fd5b60200101906001600160f81b031916908160001a905350600f60fb1b8160018151811061188957634e487b7160e01b600052603260045260246000fd5b60200101906001600160f81b031916908160001a90535060006118ad8460026122ba565b6118b89060016122a2565b90505b600181111561194c576f181899199a1a9b1b9c1cb0b131b232b360811b85600f16601081106118fa57634e487b7160e01b600052603260045260246000fd5b1a60f81b82828151811061191e57634e487b7160e01b600052603260045260246000fd5b60200101906001600160f81b031916908160001a90535060049490941c9361194581612320565b90506118bb565b5083156109205760405162461bcd60e51b815260206004820181905260248201527f537472696e67733a20686578206c656e67746820696e73756666696369656e74604482015260640161042b565b60008181526001830160205260408120548015611aae5760006119bf6001836122d9565b85549091506000906119d3906001906122d9565b9050818114611a54576000866000018281548110611a0157634e487b7160e01b600052603260045260246000fd5b9060005260206000200154905080876000018481548110611a3257634e487b7160e01b600052603260045260246000fd5b6000918252602080832090910192909255918252600188019052604090208390555b8554869080611a7357634e487b7160e01b600052603160045260246000fd5b600190038181906000526020600020016000905590558560010160008681526020019081526020016000206000905560019350505050610457565b6000915050610457565b828054611ac490612337565b90600052602060002090601f016020900481019282611ae65760008555611b2c565b82601f10611aff57805160ff1916838001178555611b2c565b82800160010185558215611b2c579182015b82811115611b2c578251825591602001919060010190611b11565b50611b38929150611b3c565b5090565b5b80821115611b385760008155600101611b3d565b600067ffffffffffffffff831115611b6b57611b6b6123d0565b604051611b82601f8501601f191660200182612372565b809150838152848484011115611b9757600080fd5b83836020830137600060208583010152509392505050565b80356001600160a01b038116811461046b57600080fd5b600082601f830112611bd6578081fd5b81356020611be38261227e565b604051611bf08282612372565b8381528281019150858301600585901b87018401881015611c0f578586fd5b855b85811015611c2d57813584529284019290840190600101611c11565b5090979650505050505050565b600082601f830112611c4a578081fd5b61092083833560208501611b51565b60008060408385031215611c6b578182fd5b611c7483611baf565b9150611c8260208401611baf565b90509250929050565b600080600080600060a08688031215611ca2578081fd5b611cab86611baf565b9450611cb960208701611baf565b9350604086013567ffffffffffffffff80821115611cd5578283fd5b611ce189838a01611bc6565b94506060880135915080821115611cf6578283fd5b611d0289838a01611bc6565b93506080880135915080821115611d17578283fd5b50611d2488828901611c3a565b9150509295509295909350565b600080600080600060a08688031215611d48578081fd5b611d5186611baf565b9450611d5f60208701611baf565b93506040860135925060608601359150608086013567ffffffffffffffff811115611d88578182fd5b611d2488828901611c3a565b60008060408385031215611da6578182fd5b611daf83611baf565b915060208301358015158114611dc3578182fd5b809150509250929050565b60008060408385031215611de0578182fd5b611de983611baf565b946020939093013593505050565b600080600060608486031215611e0b578283fd5b611e1484611baf565b95602085013595506040909401359392505050565b60008060408385031215611e3b578182fd5b823567ffffffffffffffff80821115611e52578384fd5b818501915085601f830112611e65578384fd5b81356020611e728261227e565b604051611e7f8282612372565b8381528281019150858301600585901b870184018b1015611e9e578889fd5b8896505b84871015611ec757611eb381611baf565b835260019690960195918301918301611ea2565b5096505086013592505080821115611edd578283fd5b50611eea85828601611bc6565b9150509250929050565b600060208284031215611f05578081fd5b5035919050565b60008060408385031215611f1e578182fd5b82359150611c8260208401611baf565b60008060408385031215611f40578182fd5b50508035926020909101359150565b600060208284031215611f60578081fd5b81356109208161248f565b600060208284031215611f7c578081fd5b81516109208161248f565b60008060408385031215611f99578182fd5b82359150602083013567ffffffffffffffff811115611fb6578182fd5b8301601f81018513611fc6578182fd5b611eea85823560208401611b51565b6000815180845260208085019450808401835b8381101561200457815187529582019590820190600101611fe8565b509495945050505050565b600081518084526120278160208601602086016122f0565b601f01601f19169290920160200192915050565b60007f416363657373436f6e74726f6c3a206163636f756e7420000000000000000000825283516120738160178501602088016122f0565b7001034b99036b4b9b9b4b733903937b6329607d1b60179184019182015283516120a48160288401602088016122f0565b01602801949350505050565b6001600160a01b0386811682528516602082015260a0604082018190526000906120dc90830186611fd5565b82810360608401526120ee8186611fd5565b90508281036080840152612102818561200f565b98975050505050505050565b6001600160a01b03868116825285166020820152604081018490526060810183905260a0608082018190526000906121489083018461200f565b979650505050505050565b6000602082526109206020830184611fd5565b6000604082526121796040830185611fd5565b828103602084015261218b8185611fd5565b95945050505050565b600060208252610920602083018461200f565b60208082526028908201527f455243313135353a204552433131353552656365697665722072656a656374656040820152676420746f6b656e7360c01b606082015260800190565b60208082526025908201527f455243313135353a207472616e7366657220746f20746865207a65726f206164604082015264647265737360d81b606082015260800190565b6020808252602a908201527f455243313135353a20696e73756666696369656e742062616c616e636520666f60408201526939103a3930b739b332b960b11b606082015260800190565b600067ffffffffffffffff821115612298576122986123d0565b5060051b60200190565b600082198211156122b5576122b56123ba565b500190565b60008160001904831182151516156122d4576122d46123ba565b500290565b6000828210156122eb576122eb6123ba565b500390565b60005b8381101561230b5781810151838201526020016122f3565b8381111561231a576000848401525b50505050565b60008161232f5761232f6123ba565b506000190190565b600181811c9082168061234b57607f821691505b6020821081141561236c57634e487b7160e01b600052602260045260246000fd5b50919050565b601f8201601f1916810167ffffffffffffffff81118282101715612398576123986123d0565b6040525050565b60006000198214156123b3576123b36123ba565b5060010190565b634e487b7160e01b600052601160045260246000fd5b634e487b7160e01b600052604160045260246000fd5b600060033d1115610bab57600481823e5160e01c90565b600060443d101561240d57610bab565b6040516003193d81016004833e81513d67ffffffffffffffff816024840111818411171561243f575050505050610bab565b828501915081518181111561245957505050505050610bab565b843d870101602082850101111561247557505050505050610bab565b61248460208286010187612372565b509094505050505090565b6001600160e01b031981168114610eff57600080fdfea264697066735822122010a6e45327d4a6eea6b2025e0f427495da29bd1710bc32ee7b827823d8b89e6364736f6c63430008030033";
